module.exports = __webpack_public_path__ + "static/media/avatar-04.f9bbb4fd.svg";